import { AuthGuardData, createAuthGuard } from 'keycloak-angular';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import Keycloak from 'keycloak-js';

const isAccessAllowed = async (
  route: ActivatedRouteSnapshot,
  __: RouterStateSnapshot,
  authData: AuthGuardData,
): Promise<boolean | UrlTree> => {
  const keycloak = inject(Keycloak);
  const { authenticated } = authData;

  if (!authenticated) {
    return keycloak.login().then(() => false);
  }
  return true;
};

export const canActivateAuth = createAuthGuard<CanActivateFn>(isAccessAllowed);